/* src/app/shared/loader/loader.component.scss */
@keyframes bouncing {
  0% {
    top: 40%;
  }
  100% {
    top: 30%;
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.page-overlay-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 1009;
  background: rgba(128, 128, 128, 0.5);
}
.page-overlay-wrapper .bee-spinner {
  width: 10%;
  height: 10%;
  position: fixed;
  top: 40%;
  left: 50%;
  z-index: 100;
  background-image: url("./media/loader-Q66YOFO2.gif");
  background-repeat: no-repeat;
  background-size: 25%;
}
/*# sourceMappingURL=loader.component-FD34FKX5.css.map */
